import store from '@/store';


/**
 * 团队游按钮权限校验
 * 传入值若为ADMIN 这管理员直接放行,MASTER 则只有组长放行
 *
 *
 */
export const teamAuth = {


    inserted(el, binding,vnode) {

        let {role} = store.state.user.teamInfo.myInTeamInfo
        //组长直接放行
        if (binding.value){
            if (role==='MASTER'){
                return true
            }else if (role==='ADMIN'){
                const authorizations = JSON.parse(store.state.user.teamInfo.authorizations)
                if (!authorizations.includes(binding.value)&&binding.value!=='ADMIN'){
                    removeNode(el,vnode)
                }
            }else{
                removeNode(el,vnode)
            }
        }else {
            "need perms! Like v-team-auth='MEMBER'"
        }
  }
};

const removeNode = (el,vnode)=>{
    const comment = document.createComment(' ');
    Object.defineProperty(comment, 'setAttribute', {
        value: () => undefined,
    });
    vnode.elm = comment;
    vnode.text = ' ';
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;

    if (vnode.componentInstance) {
        vnode.componentInstance.$el = comment;
    }

    if (el.parentNode) {
        el.parentNode.replaceChild(comment, el);
    }
}

/**
 * 团队
 */
export const teamMemberAuth = {
    inserted(el, binding,vnode) {
        let {role} = store.state.user.teamInfo.myInTeamInfo
        //组长直接放行
        if (binding.value){
            if (role==='MASTER'){
                return true
            }else if (role==='ADMIN'){
                return true
            }else{
                const authorizations = JSON.parse(store.state.user.teamInfo.authorizations)
                if (!authorizations.includes(binding.value)){
                    removeNode(el,vnode)
                }
            }
        }else {
            "need perms! Like v-team-auth='MEMBER'"
        }
    }
};
